export const PersonalData = [
  {
    type: "Phone",
    icon: <i className="fi fi-rr-phone-flip option-icon"></i>,
    value: "+91-9807264357",
  },
  {
    type: "Email",
    icon: <i className="fi fi-rr-envelope option-icon"></i>,
    value: "nikhilgupta150498@gmail.com",
  },
  {
    type: "Location",
    icon: <i className="fi fi-rr-marker option-icon"></i>,
    value: "Noida, India",
  },
];
